import angular from 'angular';
import _ from 'lodash';
import { RECRUITER_WORKFLOW_STATUS } from '../../../components/recruiter/constants/recruiter-workflow';
import { EMPLOYER_WORKFLOW_STATUS } from '../../../components/employer/constants/employer-workflow';

const recruiterClaimedStatuses = [
    RECRUITER_WORKFLOW_STATUS.CLAIMED,
    RECRUITER_WORKFLOW_STATUS.ENGAGED,
    RECRUITER_WORKFLOW_STATUS.SENT,
    RECRUITER_WORKFLOW_STATUS.HIRED,
    RECRUITER_WORKFLOW_STATUS.READY,
];

const employerClaimedStatuses = [
    EMPLOYER_WORKFLOW_STATUS.REVIEWED,
    EMPLOYER_WORKFLOW_STATUS.INTERVIEW_AND_ASSESSMENT,
    EMPLOYER_WORKFLOW_STATUS.HIRED,
    EMPLOYER_WORKFLOW_STATUS.REJECTED,
];

export const BulkClaimService = () => {
    const getCounters = ({ candidates, recruiterId }) => {
        const initialResult = {
            aboutToClaim: [],
            alreadyClaimed: [],
            alreadyClaimedByAnotherRecruiter: [],
            processedByEmployer: [],
            hidden: [],
            rejected: [],
        };

        return _.chain(candidates || [])
            .filter(candidate => candidate.check)
            .reduce((accumulator, candidate) => {
                const recruiterStatus = _.get(candidate, 'workflow.recruiterStatus.current');
                const employerStatus = _.get(candidate, 'workflow.employerStatus.current');
                const workflowRecruiterId = _.get(candidate, 'workflow.recruiterId');
                const isHidden = recruiterStatus === RECRUITER_WORKFLOW_STATUS.HIDDEN && recruiterId === workflowRecruiterId;
                const isRejected = recruiterStatus === RECRUITER_WORKFLOW_STATUS.REJECTED;
                const isClaimed = recruiterClaimedStatuses.includes(recruiterStatus);
                const isClaimedByAnotherRecruiter = isClaimed && recruiterId && recruiterId !== workflowRecruiterId;
                const isProcessedByEmployer = employerClaimedStatuses.includes(employerStatus);
                if (isHidden) {
                    accumulator.hidden.push(candidate);
                } else if (isRejected) {
                    accumulator.rejected.push(candidate);
                } else if (isClaimedByAnotherRecruiter) {
                    accumulator.alreadyClaimedByAnotherRecruiter.push(candidate);
                } else if (isClaimed) {
                    accumulator.alreadyClaimed.push(candidate);
                } else if (isProcessedByEmployer) {
                    accumulator.processedByEmployer.push(candidate);
                } else {
                    accumulator.aboutToClaim.push(candidate);
                }
                return accumulator;
            }, initialResult)
            .value();
    };

    return {
        getCounters,
    };
};

angular.module('TALENYA-FE').factory('BulkClaimService', BulkClaimService);
